import axios from 'axios'
import store from '@/store'

const isPlainObject = (v) =>
  Object.prototype.toString.call(v) === '[object Object]';

const localDateToUTC = (data) => {
  if (data instanceof Date) {
    // Get rid of timezones!
    data.setUTCDate (data.getDate())
    data.setUTCHours (data.getHours())
    data.setUTCMinutes (data.getMinutes())
    return data.toISOString();
  }
  if (Array.isArray(data)) {
    return data.map((val) => localDateToUTC(val));
  }
  if (isPlainObject(data)) {
    return Object.fromEntries(
      Object.entries(data).map(([key, val]) => [key, localDateToUTC(val)]),
    );
  }
  return data;
};

export const apiAxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true,
    xsrfCookieName: 'csrf_access_token',
    xsrfHeaderName: 'X-CSRF-TOKEN',
    transformRequest: [ localDateToUTC ].concat(axios.defaults.transformRequest)
})

export const refreshAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  xsrfCookieName: 'csrf_refresh_token',
  xsrfHeaderName: 'X-CSRF-TOKEN'
})

// Check for expired access tokens:
apiAxiosInstance.interceptors.response.use (
  response => response,
  error => {
    const {config: originalRequest, response: {status}} = error

    originalRequest.retries = originalRequest.retries || { count: 0 }

    // Check if this is an expired access token error
    if (status === 401 && originalRequest.retries.count < 3) {
      let tokenRefreshCall = store.getters['auth/refresh_token_call']

      // Dispatch a token refresh if there is none processing
      if (!tokenRefreshCall) {
        tokenRefreshCall = store.dispatch('auth/refreshAccessToken')
      }

      originalRequest.retries.count += 1

      // Wait for the new access token and then fire up another request
      return tokenRefreshCall.then (() => {
        return apiAxiosInstance (originalRequest)
      })
    }
    
    return Promise.reject (error)
  }
)

export default apiAxiosInstance